module.exports = __webpack_public_path__ + "static/media/worldwide-small.e09b30c7.jpg";